import React from "react";
import TicketCenterService from "../../../../services/management/TicketCenterService";
import NotFoundDataInDate from "../../../shared/not-found-data-in-date/NotFoundDataInDate";
import TicketListIState, { TicketListIProps } from "./TicketList.models";
import "./TicketList.scss";
import { NavLink } from "react-router-dom";
import Cartimage from "../../../../assest/images/card-image/ItemAvatar08.png";

export default class TicketList extends React.PureComponent<
  TicketListIProps,
  TicketListIState
> {
  ticketCenterService: TicketCenterService;
  constructor(props: any) {
    super(props);
    this.ticketCenterService = new TicketCenterService();
    this.state = {
      tickets: { rows: [], totalRowCount: 0 },
      queryString: {
        orderField: "ID",
        pageSize: 1000,
        pageSkip: 0,
        descendingOrder: true,
      },
    };
  }

  componentDidMount() {
    let self = this;
    self.ticketCenterService
      .getPaged(self.state.queryString)
      .then(function (response) {
        self.setState({
          tickets: response,
        });
      });
  }

  render(): React.ReactNode {
    let content;
    let { tickets } = this.state;
    if (tickets.totalRowCount > 0)
      content = (
        <>
          {tickets.rows.map(function (ticket, key) {
            return <div className="col-12 notspace" key={key}>
              <div className="tk-inline card-boundel">
                <div className="col-2 notspace" style={{ display: "flex" }}>
                  <img src={Cartimage} width="56" height="72" alt="" />
                </div>
                <div
                  className="col-7 notspace"
                  style={{ textAlign: "right", marginRight: "20px" }}
                >
                  <div className="pd-detail">
                    <div className="course-title">
                      <label>{ticket.title}</label>
                    </div>
                    <div className="course-subtitle">
                      <label>{ticket.ticketNumber}</label>
                    </div>
                  </div>
                </div>
                <div className="col-3 notspace">
                  <NavLink to={"/"}>
                    <button className="downloadBox" style={{ outline: "none" }}>
                      مشاهده
                    </button>
                  </NavLink>
                </div>
              </div>
            </div>;
          })}
        </>
      );
    else
      content = (
        <>
          <NotFoundDataInDate title="موردی جهت نمایش وجود ندارد"/>
        </>
      );

    return (
      <>
        <div className="dropdown-list ticket-list-area mt-3">
          {content}
        </div>
      </>
    );
  }
}
